import React, {useEffect, useState} from "react";
import neverLandUtils from "../../utils/NeverLandUtils";


const BarGraph = ({item, isPercentValue = false, maxValue = -1}) => {
  const [homeWidth, setHomeWidth] = useState(0);
  const [awayWidth, setAwayWidth] = useState(0);

  let homeValue = Math.abs(Number(item.home)); //절댓값 반환
  let awayValue = Math.abs(Number(item.away));
  let totalValue = homeValue + awayValue;

  if (item.name === '점유율') {
    totalValue = 100;
  } else if (isPercentValue) {  // % 들어가는 항목은 최고점 100으로
    totalValue = 100;
  } else if (maxValue > 0) {  // maxValue 값이 0 이상이면 최대값을 홈 + 원정 합친값이 아니라 maxValue 로 지정
    totalValue = maxValue - 10;
  }
  // 최대값이 maxValue 넘어가면 100%로 제한
  homeValue = totalValue === 0 ? 0 : Math.min(homeValue * 100 / totalValue, 100); 
  awayValue = totalValue === 0 ? 0 : Math.min(awayValue * 100 / totalValue, 100);

  console.log("📌 item->",item.name ,"isPercentValue->",isPercentValue , "maxValue->",maxValue, "totalValue->",totalValue);

  useEffect(() => {
    // 일정 시간 후에 막대 너비 값을 업데이트하여 애니메이션 발생
    setTimeout(() => {
      setHomeWidth(homeValue);
      setAwayWidth(awayValue);
    }, 100);
  }, [item]);

  const compareScore = (score1, score2, name) => {
    // 점수비교하기
    let reverseList = ["오프사이드", "엘로카드", "역습당한횟수", "레드카드"];
    if (reverseList.includes(name)) {
      return score1 < score2; // 작은 값이 빨간색
    } else {
      return score1 > score2; // 큰 값이 빨간색
    }
  }

  // 임시로 데이터 없는 항목 "준비중"으로 처리 ex : ["역습당한횟수", "엘로카드", "레드카드"];
  const pendingNames = [];

  return (
      <div className="flex flex-row items-center mb-2 text-sm relative">
        {/* 이름 */}
        <span className="absolute inset-0 flex justify-center items-center text-white font-bold z-10"
              style={{
                textShadow: `
                  -1px -1px 0 black,
                  1px -1px 0 black,
                  -1px 1px 0 black,
                  1px 1px 0 black
                `,
              }}
        >
          {pendingNames.includes(item.name) ? "준비중" : item.name}
        </span>

        {/* 홈팀 그래프 */}
        <span
            className={neverLandUtils.classNames(compareScore(Number(item.home), Number(item.away), item.name) ? "text-red-600" : "text-black", "w-10 text-right pr-2")}>
          {item.home}
        </span>
        <div className="flex-1 flex flex-row items-center">
          <div className="bg-gray-200 h-4 transition-all duration-1000 ease-in-out"
               style={{width: `${100 - homeWidth}%`}} // 남은 영역 채우기
          />
          <div
              className="bg-red-600 h-4"
              style={{width: `${homeWidth}%`}} // item.homePercentage 값에 따라 너비 설정
          />
        </div>


        {/* 원정팀 그래프 */}
        <div className="flex-1 flex flex-row-reverse items-center">
          <div className="bg-gray-200 h-4 transition-all duration-1000 ease-in-out"
               style={{width: `${100 - awayWidth}%`}}
          />
          <div
              className="bg-blue-700 h-4"
              style={{width: `${awayWidth}%`}}
          />
        </div>
        <span
            className={neverLandUtils.classNames(compareScore(Number(item.away), Number(item.home), item.name) ? "text-red-600" : "text-black", "w-10 text-left pl-2")}>
          {item.away}
        </span>
      </div>
  )
}
export default BarGraph;